import moment from "moment";
import common from '../../common.module.css';
import { ScheduleInGoogleCalendar } from '../commonComponents/ScheduleInGoogleCalendar';
import Text from "@UI/New/Text";
import classNames from "classnames";
import { CollapsePanel } from "@UI/New/CollapsePanel";
import { TextareaWhite } from "@UI/New/InputWhite";
import CheckboxViolet from "@UI/New/ChecboxViolet/CheckboxViolet";
import Button from "@UI/New/Button";
import { getLinkAndTextTypeOfLesson } from "../../helpers/getLinkAndTextTypeOfLesson";
import { useSelector } from "react-redux";

export const ContentForSeminarian = ({report}) => {
    const dateTimeEntryIntoClass = report?.opened_at ? moment(report?.opened_at).format('DD MMMM YYYY [в] HH:mm') : 'Не сохранено';
    const lesson = getLinkAndTextTypeOfLesson({lesson: report?.access_journal})
    const isSeparateLinksForStudentsAndTeachers = useSelector(store => store.settings.isSeparateLinksForStudentsAndTeachers);
    
    return (
       <div className={common.wrapper}>
            <div className={classNames(common.row, common.noRowInMobile)}>
                <Text 
                    texts = {report.seminariansNames} 
                />
                {
                    !!report?.isOffline && (
                         <Text 
                            type='grey'
                            texts = {[report.audienceNumber]} 
                        />
                    )
                }
            </div>
            <div className={common.row}>
                <Text 
                    type='lightGray'
                    title='Дата урока'
                    texts = {[moment(report?.date_conference).format('DD.MM.YYYY')]} 
                />
                <Text 
                    type='lightGray'
                    title='Начало'
                    texts = {[report?.start_time]} 
                />
                <Text 
                    type='lightGray'
                    title='Окончание'
                    texts = {[report?.end_time]} 
                />
            </div>
            {
                    !report?.isOffline && !!report?.link_to_meeting && (
                        <div className={common.row}>
                            <Text 
                                type='lightGray'
                                title='Скопировать ссылку на встречу'
                                texts = {[report?.link_to_meeting]} 
                                copy = {
                                    {
                                        show: true,
                                        copyText: 'Ссылка успешно скопирована'
                                    }
                                }
                            />
                        </div>
                )
            }
            {
                    !report?.isOffline && !!report?.link_to_meeting_for_children && isSeparateLinksForStudentsAndTeachers == '1' &&  (
                        <div className={common.row}>
                            <Text 
                                type='lightGray'
                                title='Скопировать ссылку на встречу (для учащихся)'
                                texts = {[report?.link_to_meeting_for_children]} 
                                copy = {
                                    {
                                        show: true,
                                        copyText: 'Ссылка успешно скопирована'
                                    }
                                }
                            />
                        </div>
                )
            }
            {
                !!lesson && (
                    <div className={common.lessonLinkRow}>
                        <span>{lesson.textType + lesson.name ?? ''}</span>
                        <a href={lesson.link}>
                            <Button 
                                color='secondary'
                                onClick={()=>{}}
                                className={common.button}>
                                Перейти
                            </Button>
                        </a> 
                    </div>
                )
            }
            <div className={common.row}>
                {/* <Text 
                    type='lightGray'
                    title='Скидка'
                    texts = {['10%']} 
                    className={common.discount}
                /> */}
                <Text 
                    type='lightGray'
                    title='Комментарий (для учащихся)'
                    texts = {[report.comment_to_dz ?? '']} 
                    className={common.comment}
                />
            </div> 
            <div className={common.row}>
                <ScheduleInGoogleCalendar />
                <Text 
                    type='lightGray'
                    title='Время захода на сессию'
                    texts = {[dateTimeEntryIntoClass]} 
                    className={common.time}
                />
            </div>
            <CollapsePanel
                className={common.collapsePanel} 
                header='Дополнительно'
            >
                <div className={common.row}>
                    <Text 
                        type='lightGray'
                        title='Комментарий (для сотрудников)'
                        texts = {[report.comment ?? '']} 
                        className={common.comment}
                    />
                </div>
                <div className={common.column}>
                    <CollapsePanel className={common.collapsePanelWhite} header='Участники звонка'>
                        <div className={classNames(common.checkboxsWrapper, 'customScroll')}>
                            {
                                report?.attendeesText?.map((children) => (
                                    <CheckboxViolet 
                                        onClick={() => {}}
                                        value={true}
                                        text={children} />
                                ))
                            }
                        </div>
                    </CollapsePanel>
                    <CollapsePanel className={common.collapsePanelWhite} header='Список сотрудников на звонке'>
                        <div className={classNames(common.checkboxsWrapper, 'customScroll')}>
                            {
                                report?.seminariansNames?.map((seminarian) => (
                                    <CheckboxViolet 
                                        onClick={() => {}}
                                        value={true}
                                        text={seminarian} />
                                ))
                            }
                        </div>
                    </CollapsePanel>
                </div>
            </CollapsePanel>
       </div>
    )
}